/* eslint-disable rxjs/no-unsafe-first */
/* eslint-disable rxjs/no-unsafe-switchmap */
/* eslint-disable rxjs/no-unsafe-catch */
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NavigationStart, Router } from '@angular/router';
import { WINDOW } from '@ng-web-apis/common';
import { Actions, concatLatestFrom, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, race, timer } from 'rxjs';
import {
    catchError,
    concatMap,
    delay,
    distinctUntilChanged,
    filter,
    first,
    map,
    mergeMap,
    switchMap,
    takeUntil,
    tap,
} from 'rxjs/operators';

import { ToggleChat } from '../../../chat/store/chat.actions';
import { ViewItemService } from '../../../product/product-view/services/view-item.service';
import { MakeSearch } from '../../../search/infrastructure/state/search.actions';
import { GridTypes } from '../../../ui/models/grid-type.model';
import { AnalyticsCartAction } from '../../constants/cart/analytics-cart.constants';
import { AnalyticsAction } from '../../services/analytics.constants';
import { LoadEventError, LoadEventSuccess } from '../../store/analytics.actions';
import { GA4ConfigurationEvents } from '../configs/ga4-configuration-events.class';
import { AnalitycsCartCategoryToEventFrom, Ga4TypeHelp } from '../constants/ga4-analytics.constants';
import { isValidModal, isValidSidebarComponent } from '../helpers/ga4-context.helper';
import { GA4EventConfiguration } from '../models/configuration.model';
import {
    Ga4ContentType,
    Ga4EventLocation,
    GA4ImActionType,
    Ga4ImTypeForAuthentication,
    Ga4ImTypeNotification,
} from '../models/event-data.model';
import { GA4Event, GA4EventType } from '../models/general.model';
import { GA4AnalyticsPublicActions } from '../public.api';
import { GA4EventParserService } from '../services/ga4-event-parser.service';
import { initBeforeUnloadListener, setPageReferrer } from '../services/ga4-page-referrer.service';

import * as GA4AnalyticsActions from './ga4-analytics.actions';
import {
    Ga4SavePageReferrerSuccess,
    Ga4SetPageviewSent,
} from './ga4-analytics.actions';
import {
    getPageViewIsSend,
} from './ga4-analytics.selectors';

import { ApiSizeInfo } from '@api/_api/api-cart/api-cart.models';
import { CartItem } from '@api/cart/cart.models';
import { Product } from '@api/catalog/products/products.models';
import { CommonWindow } from '@core/domain/models/common-window.model';
import { PageSection } from '@core/domain/types/page-sections.types';
import { SetPage } from '@core/infrastructure/state/core-commands.actions';
import { getCmsConfigValue } from '@core/infrastructure/state/core.selectors';
import { CategoriesSelectors } from '@features/category';
import { MenuCategory } from '@features/category/domain/models/menu-category.model';
import { FeelSubscriptionFeaturePublicActions } from '@features/feel/public.api';
import { getProductsList } from '@features/productsArray/infrastructure/state/productsArray.selectors';
import { getSearchType } from '@features/search/infrastructure/state/selectors/search.selectors';
import { SidebarSelectors } from '@features/sidebar';
import {
    CloseSidebarCustom,
    OpenSidebar,
    OpenSidebarCustomSuccess,
    ShowMiniWish,
} from '@features/sidebar/infrastructure/state/sidebar.actions';
import { getSidebarLoadedComponent } from '@features/sidebar/infrastructure/state/sidebar.selectors';
import { DeleteItemWishlistAction } from '@features/wishlist/infrastructure/state/wishlist-commands.actions';
import { WishlistPublicActions, WishlistPublicSelectors } from '@features/wishlist/public.api';
import { routerPublicQueries } from '@frontend/libs/duttirouter';
import {
    DeclineLinkedAccount,
    LaunchLinkedAccountModal,
    RegisterConfirmationInitialized,
    RegisterSuccessAction,
    SetLinkedAccount,
    SetLinkedAccountError,
} from '@pages/authentication/store/authentication.actions';
import { SetGridTypeCategoryGrid } from '@pages/category/modules/category-grid/store/category-grid.actions';
import { getGridType } from '@pages/category/modules/category-grid/store/category-grid.selectors';
import { SetGridTypeCustomCategoryGrid } from '@pages/category/modules/grid-custom-category/store/custom-category-grid.actions';
import { LoadCategorySuccess } from '@pages/category/store/category-page.actions';
import { getIsCategory } from '@pages/category/store/category-page.selectors';
import { SendCheckoutShippingError } from '@pages/checkout/shipping/store/shipping/shipping.actions';
import { OrderReturnStep } from '@pages/my-account/sections/returns/models/returns.models';
import { SetReturnStep } from '@pages/my-account/sections/returns/store/order-return/order-return.actions';
import { SetColorOnSelectedProduct } from '@pages/product/store/product-page.actions';
import { getCurrentProduct, getProductPageDetail } from '@pages/product/store/product-page.selectors';
import { EventFrom } from '@shared/analytics/COMMON/models/analytics-common.models';
import { ConfigurationService } from '@shared/analytics/COMMON/services/configuration.service';
import { sendObservabilityLog } from '@shared/analytics/ITXObservabilityCore/helper';
import { YesOrNoTypeString } from '@shared/analytics/models/general/general.models';
import {
    BundleClickAnalytics,
    ChatMessageAnalytics,
    ClickHeaderFeelJoinAnalytics,
    ClickOnCartAnalytics,
    ClickProductoBuscadorAnalytics,
    ControlCartAnalytics,
    EventFormErrorAnalytics,
    HeaderEventAnalytics,
    ProductClickAnalytics,
    RelatedProductClickAnalytics,
    SeleccionarTallaAnalytics,
    ShowHelpProductAnalytics,
    ShowSizeGuideAnalytics,
    ShowWishlistAnalytics,
    SubscribeComingSoonBackSoonAnalytics,
} from '@shared/analytics/store/app-events-analytics.actions';
import { OpenSearchFromHeader } from '@shared/header/store/header.actions';
import { GoToCategory, GoToSection } from '@shared/navigation/store/navigation.actions';
import { getCheckoutAuth } from '@shared/navigation/store/navigation.selectors';
import { InitTertiaryLoadSuccess } from '@shared/priorities/store/priorities-core.actions';
import { LoadSizeGuideProduct } from '@shared/product/modals/size-guide/store/size-guide.actions';
import { LoadAsyncCheckoutError } from '@shared/purchase/store/purchase.actions';
import {
    AdjustItemSizeShopcart,
    LoadShopCartSuccessAndDeleteItemFromWishlist,
} from '@shared/shopcart/store/shopcart.actions';
import { getIsSocialLogin } from '@shared/user/store';
import { CloseModalFromComponent, OpenModalFromComponent } from '@ui/dialog/store/modal.actions';
import { getActiveModalData } from '@ui/dialog/store/modal.selectors';

@Injectable()
export class GA4AnalyticsEffects implements OnInitEffects {
    private readonly getMenuCategories$: Observable<
    MenuCategory[]> = this.store.select(CategoriesSelectors.getMenuCategories);

    constructor(
        private readonly store: Store,
        private readonly actions$: Actions,
        private readonly ga4ConfigurationEvents: GA4ConfigurationEvents,
        private readonly ga4EventParserService: GA4EventParserService,
        private readonly viewItemService: ViewItemService,
        private readonly router: Router,
        @Inject(DOCUMENT) private readonly document: Document,
        @Inject(WINDOW) private readonly window: CommonWindow,
        private readonly configurationService: ConfigurationService,
        private readonly translateService: TranslateService,
    ) { }

    public ngrxOnInitEffects(): Action {
        return GA4AnalyticsActions.InitRefererResetTracking();
    }

    private getGa4Configuration(action) {
        const ga4Configuration: GA4EventConfiguration = this.ga4ConfigurationEvents.getConfigurationCodeEvent(action.name);
        return {
            ...action,
            config: ga4Configuration,
        };
    }

    private getObservableBasedOnAction<T extends Action & { name: string }>(action: T): Observable<any> {
        let obs$: Observable<any> = of(true);
        if (action.name !== GA4EventType.page_view) {
            obs$ = this.store.select(getPageViewIsSend);
        }
        return obs$;
    }

    private prepareGa4Event(action) {
        const ga4Event: Observable<GA4Event> = this.ga4EventParserService.prepareGroupParams(
            action.config,
            action.eventFrom,
            action.data,
        );
        return ga4Event;
    }

    public ga4Event$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GA4AnalyticsActions.Ga4Event),
            concatMap((action) => this.configurationService.getIsGTMLoadedWithActualInfo$<typeof action>(action)),
            filter((action) => !!action),
            map((action) => this.getGa4Configuration(action)),
            mergeMap((action) => {
                return this.getObservableBasedOnAction<typeof action>(action).pipe(
                    filter(obs => obs === true),
                    first(),
                    concatLatestFrom(() => this.prepareGa4Event(action)),
                    map(([_, ga4Event]) => GA4AnalyticsActions.Ga4SendDatalayer({
                        dataLayer: ga4Event,
                        eventFrom: action.eventFrom,
                    })),
                    catchError((error: string) => of(GA4AnalyticsActions.Ga4EventError({ error }))),
                );
            }),
        );
    });

    public Ga4EventError$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GA4AnalyticsActions.Ga4EventError),
            tap((action) => {
                console.error(action.error);
            }),
        );
    }, { dispatch: false });

    public ga4SendDatalayer$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GA4AnalyticsActions.Ga4SendDatalayer),
            tap(action => {
                this.window.dataLayer.push(action.dataLayer);
            }),
            map((action) => {
                return LoadEventSuccess({
                    payload: {
                        type: 'ga4Event',
                        dataObject: action.dataLayer,
                        eventFrom: action.eventFrom,
                    },
                });
            }),
            catchError((error: string) => {
                console.error(error);
                return of(LoadEventError());
            })
        );
    });

    private readonly NON_PAGEVIEW_MODALS_AND_SIDEBARS = ['app-feel-subscription-modal', 'linked-account'];

    public modalOpenSetPageviewSent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(OpenModalFromComponent, OpenSidebarCustomSuccess),
            filter((action) => !this.NON_PAGEVIEW_MODALS_AND_SIDEBARS.includes((action as any)?.componentName)),
            map(() => Ga4SetPageviewSent({ isSent: false }))
        );
    });

    public modalOrSidebarCloseSetPageviewSent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CloseModalFromComponent, CloseSidebarCustom),
            filter((action) => !(action as any)?.isNavigation
                && !this.NON_PAGEVIEW_MODALS_AND_SIDEBARS.includes((action as any)?.componentName)),
            map(() => Ga4SetPageviewSent({ isSent: false }))
        );
    });

    public ga4PageviewSendSetter$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GA4AnalyticsActions.Ga4SendDatalayer),
            filter(action => action.dataLayer.event === GA4EventType.page_view),
            map(() => Ga4SetPageviewSent({ isSent: true })),
        );
    });

    public modalOrSidebarClosePageView$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CloseModalFromComponent, CloseSidebarCustom),
            filter((action) => !(action as any)?.isNavigation
                && !this.NON_PAGEVIEW_MODALS_AND_SIDEBARS.includes((action as any)?.componentName)),
            map(() => GA4AnalyticsActions.Ga4Event({ name: GA4EventType.page_view }))
        );
    });

    // NOTE: Se comenta este efecto debido a que actualmente cuando un usuario acepta las cookies, se recarga la página
    // public pageViewOnLoadGTM$ = createEffect(() => {
    //     return this.actions$.pipe(
    //         ofType(InitTertiaryLoadSuccess),
    //         switchMap(() => this.store.select(getIsGTMLoaded).pipe(distinctUntilChanged())),
    //         filter((isLoaded) => !!isLoaded),
    //         withLatestFrom(this.store.select(getPageViewIsSend)),
    //         filter(([_, isSend]) => !isSend),
    //         withLatestFrom(this.store.select(getPage)),
    //         map(([_, page]) => SetPage({ page })),
    //     );
    // });

    private readonly excludedPagesPageView: PageSection[] = [
        'ItxMyAccountPage',
    ];

    public pageViewAnalytics$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SetPage),
            filter(({ page }) => !this.excludedPagesPageView.includes(page)),
            concatMap(({ page }) => {
                try {
                    return this.configurationService.pageDeferConditions(page).pipe(
                        map((data) => {
                            if (typeof data === 'object') {
                                return GA4AnalyticsActions.Ga4Event({ name: GA4EventType.page_view });
                            }
                            return GA4AnalyticsActions.Ga4Event({
                                name: GA4EventType.page_view,
                                eventFrom: EventFrom[data],
                            });
                        })
                    );
                } catch (error) {
                    sendObservabilityLog(error, 'GA4AnalyticsActions pageViewAnalytics');
                    return of(GA4AnalyticsActions.Ga4EventError({ error }));
                }
            }),
        );
    });

    public searchPageView$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(MakeSearch),
            distinctUntilChanged(),
            filter((action) => !!action.searchTerm),
            map((data) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.page_view,
                    eventFrom: data.totalHits === '0' ? EventFrom.searchNoResults : EventFrom.search,
                });
            })
        );
    });

    public popUpViewAnalytics$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(InitTertiaryLoadSuccess, OpenModalFromComponent, OpenSidebarCustomSuccess),
            concatLatestFrom(() => [
                this.store.select(getActiveModalData),
                this.store.select(getSidebarLoadedComponent),
            ]),
            distinctUntilChanged(),
            filter(([_, activeModalData, sidebarLoadedComponent]) =>
                isValidModal(activeModalData)
                || isValidSidebarComponent(sidebarLoadedComponent)),
            map(([_, activeModalData, sidebarLoadedComponent]) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.page_view,
                    eventFrom: EventFrom[activeModalData?.name || sidebarLoadedComponent],
                });
            })
        );
    });

    public orderReturnAnalytics$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SetReturnStep),
            map((data: { step: OrderReturnStep }) => {
                let eventFrom: string;
                switch (data.step) {
                    case 0:
                        eventFrom = 'returnsOrderOptionsPage';
                        break;
                    case 1:
                        eventFrom = 'returnsOrderDeliveryPage';
                        break;
                    case 2:
                        eventFrom = 'returnsOrderListPage';
                        break;
                    case 4:
                        eventFrom = 'returnsOrderDetailPage';
                        break;
                    case 5:
                        eventFrom = 'returnsOrderConfirmationPage';
                        break;
                    default:
                        eventFrom = 'returnsOrderPage';
                        break;
                }

                return GA4AnalyticsActions.Ga4Event({ name: GA4EventType.page_view, eventFrom: EventFrom[eventFrom] });
            })
        );
    });

    public EventSelectItemGA4$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(
                ClickProductoBuscadorAnalytics,
                ProductClickAnalytics,
                RelatedProductClickAnalytics,
                ControlCartAnalytics
            ),
            // Este map es necesario porque los modelos de datos de estas acciones no están estandarizados, una vez se elimine GA3 se simplificarán.
            map((actionData) => ({ ...actionData, ...(actionData as any).data })),
            filter((actionData) => {
                return !actionData?.action
                    || [
                        AnalyticsAction.ProductClick,
                        AnalyticsAction.verVistaRapidaProducto,
                    ].includes(actionData?.action);
            }),
            concatLatestFrom(() => this.store.select(getSearchType)),
            map(([action, searchType]) => {
                const product = action?.product;
                const products = product ? [product] : action?.products;
                let eventFrom: EventFrom = AnalitycsCartCategoryToEventFrom[action?.category]
                    || action?.eventFrom || action?.parentType;

                if (eventFrom === EventFrom.search && searchType) {
                    const eventFromMap = {
                        busqueda_relacionada: EventFrom.searchAdapterNextTerm,
                        busqueda_sugerida: EventFrom.searchAdapterAutocomplete,
                        manual: EventFrom.searchAdapter,
                        trending: EventFrom.searchAdapterTrend,
                        ultimas_busquedas: EventFrom.searchAdapterLastSearchs,
                    };

                    eventFrom = eventFromMap[searchType] || eventFrom;
                }

                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.select_item,
                    eventFrom,
                    data: {
                        baseProduct: action?.baseProduct,
                        items: products,
                        place: action?.place,
                        relatedsSectionId: action?.relatedsSectionId,
                        imBundleReference: action?.extraData?.imBundleReference,
                    },
                });
            })
        );
    });

    public EventSelectItemBundleGA4$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(
                BundleClickAnalytics
            ),
            mergeMap(({ data, eventFrom }) => {
                const product = data?.product;
                const category = data?.category;

                const baseProduct = data?.baseProduct || product;
                const place = data?.place;
                const parseEventFrom: EventFrom = AnalitycsCartCategoryToEventFrom[category]
                    || eventFrom || data?.parentType;

                return product.bundleProducts.map((bundleProduct) => {
                    return GA4AnalyticsActions.Ga4Event({
                        name: GA4EventType.select_item,
                        eventFrom: parseEventFrom,
                        data: {
                            items: [bundleProduct],
                            imBundleReference: product.reference,
                            baseProduct,
                            place,
                        },
                    });
                });
            })
        );
    });

    /** START OF "VIEW_ITEM_LIST" ANALYTICS EFFECTS */

    public EventViewItemListVisibleGA4$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GA4AnalyticsActions.Ga4ItemListVisible),
            filter(({ product }) => !!product),
            map((event) => this.viewItemService.viewProduct(event.product, event?.isPassthrough, event?.isReset)),
            filter((products) => !!products?.length),
            map((items: Product[]) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.view_item_list,
                    eventFrom: EventFrom.parrilla,
                    data: {
                        items,
                    },
                });
            })
        );
    });

    public ResetIsFirstTime$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LoadCategorySuccess, SetGridTypeCategoryGrid, SetGridTypeCustomCategoryGrid),
            tap(() => {
                this.viewItemService.resetIsFirstTime();
            }),
        );
    }, { dispatch: false });

    /**
     * Efecto que se encarga de enviar el evento de analítica correspondiente con los productos que el usuario
     * vé nada más entra en una parrilla
     */
    public EventViewItemListStartGA4$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LoadCategorySuccess, SetGridTypeCategoryGrid, SetGridTypeCustomCategoryGrid),
            concatLatestFrom(() => this.store.select(getIsCategory)),
            filter(([, _isCategory]) => _isCategory),
            concatLatestFrom(() => this.store.select(getGridType)),
            filter(([, gridType]) => gridType !== GridTypes.GRID_16),
            /** Después de que cargue una categoría o se cambie el tipo de grid se espera a que se se vean los primeros productos (ga4ItemListVisible) que se cargan nada
             * más llegar (200ms) y se envía evento de analítica con estos. Se ignora un posible evento con parámetro (isReset) porque no viene de la visualización de
             * un producto sinó del evento lanzado con los productos que faltaban por enviar en la categoría o tipo de parrilla anterior al hacer un cambio */
            switchMap(() => this.actions$.pipe(
                ofType(GA4AnalyticsActions.Ga4ItemListVisible),
                filter((action) => !action.isReset),
                first(),
                delay(200),
            )),
            map(() => GA4AnalyticsActions.Ga4ItemListVisible({
                eventFrom: EventFrom.parrilla,
                product: undefined,
                isPassthrough: true,
            })),
        );
    });

    /**
     * Efecto que se encarga de enviar el evento de analítica correspondiente cuando pasan (n) segundos desde
     * que se envió el último evento "view_item_list"
     */
    public EventViewItemListTimerGA4$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GA4AnalyticsActions.Ga4Event),
            filter((event) => event.name === GA4EventType.view_item_list && event.eventFrom === EventFrom.parrilla),
            switchMap(() => timer(this.viewItemService.config.delayMilisecondsUntilEvent)),
            map(() => GA4AnalyticsActions.Ga4ItemListVisible({
                eventFrom: EventFrom.parrilla,
                product: undefined,
                isPassthrough: true,
            })),
            takeUntil(this.router.events.pipe(filter((event) => event instanceof NavigationStart))),
        );
    });

    /**
     * Efecto que se encarga de enviar el evento de analítica correspondiente cuando se navega fuera de una categoría
     */
    public EventViewItemListExitGA4$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LoadCategorySuccess),
            switchMap(() => race([
                this.router.events.pipe(filter((event) => event instanceof NavigationStart)),
                /* Como el apartado de "Mi cuenta" es aún una página legacy no se utiliza el router para navegar y se recarga la página,
                por lo que para detectar que se navega fuera de la categoría en este caso por ahora necesitamos esta línea */
                this.actions$.pipe(ofType(HeaderEventAnalytics), filter((action) => action.section === 'account')),
            ])),
            concatLatestFrom(() => this.store.select(getIsCategory)),

            filter(([, _isCategory]) => _isCategory),
            map(() => GA4AnalyticsActions.Ga4ItemListVisible({
                eventFrom: EventFrom.parrilla,
                product: undefined,
                isPassthrough: true,
                isReset: true,
            })),
        );
    });

    /**
     * Efecto que se encarga de enviar el evento de analítica correspondiente cuando se cambia el filtro en una categoría
     */
    public EventViewItemListGridChangeGA4$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SetGridTypeCategoryGrid),
            concatLatestFrom(() => this.store.select(getIsCategory)),
            filter(([, _isCategory]) => _isCategory),
            map(() => GA4AnalyticsActions.Ga4ItemListVisible({
                eventFrom: EventFrom.parrilla,
                product: undefined,
                isPassthrough: true,
                isReset: true,
            })),
        );
    });

    /**
     * Efecto que se encarga de avisar de que se han cargado todos los productos de una parrilla para inciar
     * la observación de esta para detectar cuando el usuario llega al final
     */
    public EventViewItemListEndGA4$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SetGridTypeCategoryGrid, SetGridTypeCustomCategoryGrid),
            switchMap(() => this.store.select(getProductsList)), // Importamos directamente el selector de la feature para no generar dependencia del módulo
            filter((productsArray) => Object.values(productsArray).every((value) => !!value)),
            switchMap(() => this.actions$.pipe(
                ofType(GA4AnalyticsActions.Ga4ItemListVisible),
                filter((action) => !action.isReset),
                first(),
                delay(400),
            )),
            map(() => {
                const productListElem = this.document.getElementsByClassName('grid-product-list')[0];
                this.viewItemService.actionWhenVisibleAsync(
                    undefined,
                    productListElem,
                    undefined,
                    EventFrom.parrilla,
                    undefined,
                    /** Utilizamos threshold a 0 junto con un rootMargin (márgen respecto al elemento padre) reducido al -100%
                     *  para detectar cuando se llega al final de la parrilla */
                    {
                        isOnce: true,
                        firstTimeViewTreshold: [0],
                        standardViewTreshold: [0],
                        rootMargin: '-100% 0px 0px 0px',
                    }
                );
                return productListElem;
            }),
            /* En el próximo cambio de categoría (o filtro de esta) se deja de observar el elemento de la parrilla, así evitamos que se observe
             * dos veces al realizar estas acciones de nuevo */
            switchMap((productListElem) => this.actions$.pipe(
                ofType(SetGridTypeCategoryGrid, SetGridTypeCustomCategoryGrid),
                tap(() => {
                    this.viewItemService.unobserve(productListElem);
                })
            ))
        );
    }, { dispatch: false });

    /** END OF "VIEW_ITEM_LIST" ANALYTICS EFFECTS */

    public feelCommonJoinGenerateLead$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(FeelSubscriptionFeaturePublicActions.FeelSubscriptionJoinSuccess),
            map(() => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.generate_lead,
                    eventFrom: EventFrom.feelJoin,
                });
            })
        );
    });

    public checkIsNewsletterAccepted = (form: FormGroup): boolean => {
        return !!form.value.TermsAndConditionsComponent.termsAndConditionsCheck_NC_RCRGPD
            || !!form.value.TermsAndConditionsComponent.termsAndConditionsCheck_NC_RGPDC
            || !!form.value.TermsAndConditionsComponent.termsAndConditionsCheck_NC_KC
            || !!form.value.TermsAndConditionsComponent.termsAndConditionsCheck_NC_C;
    };

    public checkIsFeelAccepted = (form: FormGroup): boolean => {
        return !!form.value.TermsAndConditionsComponent.termsAndConditionsCheck_FRC_RGPDC
            || !!form.value.TermsAndConditionsComponent.termsAndConditionsCheck_FRC_C;
    };

    public registerGenerateLeadNewsletter$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(RegisterSuccessAction),
            filter(({ form }) => this.checkIsNewsletterAccepted(form) && !!form.value.newsletter),
            map(({ form }) => {
                const newsletterForm = form.value.newsletter;
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.generate_lead,
                    eventFrom: EventFrom.newsletter,
                    data: {
                        newsletterForm,
                    },
                });
            })
        );
    });

    public registerGenerateLeadFeel$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(RegisterSuccessAction),
            filter(({ form }) => this.checkIsFeelAccepted(form)),
            map(() => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.generate_lead,
                    eventFrom: EventFrom.feelJoin,
                });
            })
        );
    });

    public beginSearchEvent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(OpenSearchFromHeader),
            map(({ from }) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.begin_search,
                    eventFrom: EventFrom[from],
                });
            })
        );
    });

    public formErrorEvent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(EventFormErrorAnalytics),
            map(({ form, formName, eventFrom }) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.error_custom,
                    data: {
                        errorType: 'error_form',
                        formValues: form,
                        formName,
                    },
                    eventFrom,
                });
            })
        );
    });

    /* Este código literal no es correcto, es un recordatorio de que muchos de estos eventos ya están
        programados con lógica validada en GA3 y se puede extraer lógica de ellos para generar los nuevos */
    // public formErrorServerEvent$ = createEffect(() => {
    //     return this.actions$.pipe(
    //         ofType(AnalyticsEvent, SendCustomAnalytics),
    //         filter(({ eventData }) => eventData.action?.includes('error_servidor')),
    //         map(({ eventData }) => {
    //             return { ...eventData, action: eventData.action.split('_').pop() };
    //         }),
    //         map((eventData) => {
    //             return GA4AnalyticsActions.Ga4Event({
    //                 name: GA4EventType.error_custom,
    //                 data: {
    //                     errorType: 'error_server_form',
    //                     formName: eventData.action,
    //                     errorDescription: eventData.label as string,
    //                 },
    //                 eventFrom: eventData.eventFrom,
    //             });
    //         })
    //     );
    // });

    public errorStockEvent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ControlCartAnalytics),
            filter(({ action }) => action === AnalyticsCartAction.stockError),
            map((eventData) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.error_custom,
                    data: {
                        errorType: 'error_stock',
                        items: [eventData.item],
                    },
                    eventFrom: EventFrom.checkout,
                });
            })
        );
    });

    public errorPaymentTypeEvent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LoadAsyncCheckoutError),
            map(({ selectedPayment }) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.error_custom,
                    data: {
                        errorType: 'error_payment_type',
                        errorDescription: selectedPayment.name,
                    },
                    eventFrom: EventFrom.checkout,
                });
            })
        );
    });

    public errorShippingTierEvent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SendCheckoutShippingError),
            map(({ selectedMethod }) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.error_custom,
                    data: {
                        errorType: 'error_shipping_tier',
                        errorDescription: selectedMethod.name,
                    },
                    eventFrom: EventFrom.checkout,
                });
            })
        );
    });

    public errorPageEvent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SetPage),
            filter(({ page }) => page === 'Itx404ErrorPage' || page === 'Itx410ErrorPage'),
            map(({ page }) => {
                if (page === 'Itx410ErrorPage') return '410';
                return '404';
            }),
            map((errorPageId) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.error_custom,
                    data: {
                        errorType: 'error_page',
                        errorDescription: errorPageId,
                    },
                    eventFrom: EventFrom.error,
                });
            })
        );
    });

    // public applyInteractionFilterEvent$ = createEffect(() => {
    //     return this.actions$.pipe(
    //         ofType(SetFilterProduct),
    //         map(({ filters, filterEmitter }) => {
    //             let isApplied: boolean = false;
    //             if (filterEmitter instanceof Object && 'filtersGroupArray' in filterEmitter) {
    //                 isApplied = Object.values(filterEmitter.filtersGroupArray[filterEmitter.filtersGroup])
    //                     .some((value: boolean) => value);
    //             } else {
    //                 isApplied = filters.order.isApplied;
    //             }
    //             return GA4AnalyticsActions.ga4Event({
    //                 name: GA4EventType.interaction_filter,
    //                 eventFrom: EventFrom.filter,
    //                 data: {
    //                     actionType: isApplied ? GA4ImActionType.applyFilter : GA4ImActionType.cleanFilter,
    //                     filterEmitter,
    //                 },
    //             });
    //         })
    //     );
    // });

    public viewItemOnProductPage$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GA4AnalyticsActions.Ga4SendDatalayer),
            filter(({ dataLayer }) =>
                dataLayer.event === GA4EventType.page_view && dataLayer.context.page_title.includes('ficha_producto')),
            // NOTE: Mover al lado de analítica ?
            concatLatestFrom(() => this.store.select(getProductPageDetail)),
            map(([_, product]) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.view_item,
                    eventFrom: EventFrom.productdetail,
                    data: {
                        items: [product],
                    },
                });
            })
        );
    });

    public setGridTypeCategoryGridEvent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SetGridTypeCategoryGrid),
            distinctUntilChanged(),
            filter((action) => !action.initGridType),
            map(({ gridType }) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.change_view_item_list,
                    eventFrom: EventFrom.parrilla,
                    data: {
                        category_view_type: gridType,
                    },
                });
            })
        );
    });

    public openInteractionChatEvent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ToggleChat),
            map(() => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.interaction_chat,
                    eventFrom: EventFrom.chat,
                    data: {
                        imActionType: GA4ImActionType.abrir_chat,
                        imLinkType: 'icono',
                        imLinkText: '¿Necesitas ayuda?',
                    },
                });
            })
        );
    });

    public firstMessageInteractionChatEvent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ChatMessageAnalytics),
            first((message: any) => message.from === 'user'),
            map(() => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.interaction_chat,
                    eventFrom: EventFrom.chat,
                    data: {
                        imActionType: GA4ImActionType.primer_mensaje_chat,
                    },
                });
            })
        );
    });

    public uniqueAccountRegisterViewContent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(RegisterConfirmationInitialized),
            concatLatestFrom(() => [
                this.store.select(getCmsConfigValue('UNIQUE_ACCOUNT_ENABLED')),
                this.store.select(routerPublicQueries.getNavigationId),
                this.store.select(getCheckoutAuth),
            ]),
            filter(([_, isUniqueAccountEnabled, navigationId]) => isUniqueAccountEnabled && navigationId > 1),
            map(([_, __, ___, checkoutAuth]) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.view_content,
                    eventFrom: undefined,
                    data: {
                        contentType: Ga4ContentType.setting,
                        contentId: 'single_account_activation',
                        imLocation: checkoutAuth ? Ga4EventLocation.checkout : Ga4EventLocation.register,
                    },
                });
            })
        );
    });

    public uniqueAccountModalViewContent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LaunchLinkedAccountModal),
            concatLatestFrom(() => [
                this.store.select(getIsSocialLogin),
                this.store.select(getCmsConfigValue('UNIQUE_ACCOUNT_ENABLED')),
                this.store.select(routerPublicQueries.getUrlFromRouter),
            ]),
            filter(
                ([
                    _,
                    isSocialLogin,
                    uniqueAccountEnabled,
                    url,
                ]) => !isSocialLogin && uniqueAccountEnabled && !url.includes('register')
            ),
            map(() => GA4AnalyticsActions.Ga4Event({
                name: GA4EventType.view_content,
                eventFrom: undefined,
                data: {
                    contentType: Ga4ContentType.setting,
                    contentId: 'single_account_activation',
                    imLocation: Ga4EventLocation.freeflow,
                },
            }))
        );
    });

    public uniqueAccountSelectContent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SetLinkedAccount, DeclineLinkedAccount),
            concatLatestFrom(() => [
                this.store.select(routerPublicQueries.getUrlFromRouter),
                this.store.select(getCheckoutAuth),
            ]),
            map(([action, currentUrl, checkoutAuth]) => {
                let imLocation;

                if (checkoutAuth) {
                    imLocation = Ga4EventLocation.checkout;
                } else {
                    imLocation = currentUrl.includes('register')
                        ? Ga4EventLocation.register
                        : Ga4EventLocation.freeflow;
                }

                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.select_content,
                    eventFrom: undefined,
                    data: {
                        contentType: Ga4ContentType.setting,
                        contentId: 'single_account_activation',
                        imLocation,
                        contentValue: action.type === SetLinkedAccount.type ? YesOrNoTypeString.si : YesOrNoTypeString.no,
                    },
                });
            })
        );
    });

    public uniqueAccountErrorCustom$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SetLinkedAccountError),
            concatLatestFrom(() => this.store.select(routerPublicQueries.getUrlFromRouter)),
            map(([action, currentUrl]) => {
                const imDetail = {
                    _APP_PERSON_REGISTER_LINKED_ACCOUNT: 'user_already_exists_in_other_inditex_group_store',
                    ACCOUNT_ALREADY_EXIST_ERROR: 'user_already_exists_in_other_inditex_group_store',
                }[action.error?.key] || 'general_error';

                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.error_custom,
                    eventFrom: undefined,
                    data: {
                        imType: Ga4ImTypeForAuthentication.single_account_activation,
                        imLocation: currentUrl.includes('register') ? Ga4EventLocation.register : Ga4EventLocation.freeflow,
                        imDetail,
                    },
                });
            })
        );
    });

    public initBeforeUnloadListener$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GA4AnalyticsActions.InitRefererResetTracking),
            tap(() => { initBeforeUnloadListener(this.window); })
        );
    }, { dispatch: false });

    public savePageReferrer$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GA4AnalyticsActions.Ga4SendDatalayer),
            filter(({ dataLayer }) => dataLayer.event === GA4EventType.page_view),
            tap(({ dataLayer }) => {
                setPageReferrer(dataLayer.context.page_location, this.window);
            }),
            map(() => Ga4SavePageReferrerSuccess())
        );
    });

    public goToCategory$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GoToCategory),
            concatLatestFrom(() => this.store.select(getIsCategory)),
            filter(([_, isCategory]) => isCategory),
            map(() => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.select_content,
                    eventFrom: EventFrom.mainMenu,
                    data: {
                        contentType: Ga4ContentType.catalog,
                        imActionType: GA4ImActionType.clickMenu,
                    },
                });
            })
        );
    });

    public changeColorProduct$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SetColorOnSelectedProduct),
            concatLatestFrom(() => [
                this.store.select(getCurrentProduct),
            ]),
            map(([_, currentProduct]) => {
                return GA4AnalyticsPublicActions.Ga4Event({
                    name: GA4EventType.select_content,
                    eventFrom: undefined,
                    data: {
                        imLocation: Ga4EventLocation.fichaProducto,
                        contentType: Ga4ContentType.product_color,
                        imActionType: GA4ImActionType.seleccionar_color,
                        contentId: currentProduct?.reference,
                        items: [currentProduct],
                    },
                });
            })
        ));

    public subscribeComingSoonBackSoon$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SubscribeComingSoonBackSoonAnalytics),
            concatLatestFrom(() => this.translateService.get('dev.product.notification.send')),
            map(([{ product }, linkText]) => {
                let imType: Ga4ImTypeNotification = undefined;

                if (product.status.selectedSize.visibilityValue === 'COMING_SOON') {
                    imType = Ga4ImTypeNotification.coming_soon;
                } else if (product.status.selectedSize.visibilityValue === 'BACK_SOON') {
                    imType = Ga4ImTypeNotification.back_soon;
                }

                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.select_content,
                    eventFrom: EventFrom['product-coming-soon-modal'],
                    data: {
                        contentId: product.reference,
                        contentType: Ga4ContentType.notification,
                        imActionType: GA4ImActionType.crear_notificacion,
                        imLinkText: linkText,
                        items: [product],
                        imType,
                    },
                });
            })
        );
    });

    public showHelpProduct$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ShowHelpProductAnalytics),
            map(({ helpType }) => {
                const actionTypeDicc: Record<Ga4TypeHelp, {
                    imActionType: GA4ImActionType;
                    linkTextKey: string;
                }> = {
                    cares: {
                        imActionType: GA4ImActionType.ver_cuidados,
                        linkTextKey: 'dev.product.composition',
                    },
                    send: {
                        imActionType: GA4ImActionType.ver_envio,
                        linkTextKey: 'dev.product.envio',
                    },
                    returns: {
                        imActionType: GA4ImActionType.ver_devolucion,
                        linkTextKey: 'dev.product.return',
                    },
                };
                return actionTypeDicc[helpType];
            }),
            concatLatestFrom(({ linkTextKey }) => [
                this.store.select(getCurrentProduct),
                this.translateService.get(linkTextKey),
            ]),
            map(([{ imActionType }, product, linkText]) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.select_content,
                    eventFrom: EventFrom.productdetail,
                    data: {
                        contentId: product.reference,
                        contentType: Ga4ContentType.product_info,
                        imLinkText: linkText,
                        items: [product],
                        imActionType,
                    },
                });
            })
        );
    });

    public loadSizeGuideProduct$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(LoadSizeGuideProduct),
            concatLatestFrom(() => this.translateService.get('dev.product.sizeGuide')),
            map(([{ product }, linkText]) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.select_content,
                    eventFrom: EventFrom.productdetail,
                    data: {
                        contentId: product.reference,
                        contentType: Ga4ContentType.product_info,
                        imActionType: GA4ImActionType.ver_guia_tallas,
                        items: [product],
                        imLinkText: linkText,
                    },
                });
            })
        );
    });

    public showSizeGuide$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ShowSizeGuideAnalytics),
            concatLatestFrom(() => [
                this.store.select(getCurrentProduct),
                this.translateService.get('dev.product.sizeGuide.measure.findSize'),
            ]),
            map(([_, product, linkText]) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.select_content,
                    eventFrom: EventFrom.productdetail,
                    data: {
                        contentId: product.reference,
                        contentType: Ga4ContentType.product_info,
                        imActionType: GA4ImActionType.ver_guia_tallas_fit,
                        imLinkText: linkText,
                        items: [product],
                    },
                });
            })
        );
    });

    public openStock$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(WishlistPublicActions.OpenStockAction),
            // REF-AN-5
            concatLatestFrom(() => this.translateService.get('dev.product.reservaTienda')),
            map(([{ product }, linkText]) => {
                return GA4AnalyticsActions.Ga4Event({
                    name: GA4EventType.select_content,
                    eventFrom: EventFrom.productdetail,
                    data: {
                        contentId: product.reference,
                        contentType: Ga4ContentType.product_info,
                        imActionType: GA4ImActionType.ver_disponibilidad_tienda,
                        imLinkText: linkText,
                        items: [product],
                    },
                });
            })
        );
    });

    public LoadMiniCartModuleGA4$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(OpenSidebar), // ECOMDUTI-21448 [TechDebt] gestionar apertura a través del param view SidebarView
            concatLatestFrom(() => [
                this.translateService.get('header_shop_cart'), // REF-AN-4
                this.store.select(SidebarSelectors.viewCart),
            ]),
            filter(([_, __, hasViewCart]) => hasViewCart),
            map(([_, linktext]) => GA4AnalyticsPublicActions.Ga4Event({
                name: GA4EventType.select_content,
                eventFrom: undefined,
                data: {
                    contentType: Ga4ContentType.cart,
                    imLocation: Ga4EventLocation.header,
                    imActionType: GA4ImActionType.ver_minicesta,
                    imLinkText: linktext,
                },
            }))
        );
    });

    public LoadMiniCartModuleGA4x$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(GA4AnalyticsActions.ShowMiniCartForAnalytics),
            // REF-AN-4
            concatLatestFrom(() => this.translateService.get('header_shop_cart')),
            map(([_, linktext]) => GA4AnalyticsPublicActions.Ga4Event({
                name: GA4EventType.select_content,
                eventFrom: undefined,
                data: {
                    contentType: Ga4ContentType.cart,
                    imLocation: Ga4EventLocation.header,
                    imActionType: GA4ImActionType.ver_minicesta,
                    imLinkText: linktext,
                },
            }))
        );
    });

    public trackGoToShopCartGA4$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GoToSection),
            filter(action => action.url === 'shopCart'),
            // REF-AN-3
            concatLatestFrom(() => this.translateService.get('dev.cart.goToShopcart')),
            map(([_, linktext]) => GA4AnalyticsPublicActions.Ga4Event({
                name: GA4EventType.select_content,
                eventFrom: undefined,
                data: {
                    contentType: Ga4ContentType.cart,
                    imLocation: Ga4EventLocation.sidebar,
                    imActionType: GA4ImActionType.ir_a_cesta,
                    imLinkText: linktext,
                },
            }))
        ));

    public trackGoToShopCart2GA4$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ClickOnCartAnalytics),
            // REF-AN-2
            concatLatestFrom(() => this.translateService.get('dev.cart.cart')),
            map(([action, linktext]) => GA4AnalyticsPublicActions.Ga4Event({
                name: GA4EventType.select_content,
                data: {
                    contentType: Ga4ContentType.cart,
                    imLocation: action.eventFrom as Ga4EventLocation,
                    imActionType: GA4ImActionType.ver_cesta,
                    imLinkText: linktext,
                },
            }))
        ));

    public openWishList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ShowWishlistAnalytics, ShowMiniWish),
            // REF-AN-5
            concatLatestFrom(() => this.translateService.get('dev.cart.wishlist')),
            map(([action, linktext]) => {
                return GA4AnalyticsPublicActions.Ga4Event({
                    name: GA4EventType.select_content,
                    eventFrom: undefined,
                    data: {
                        contentType: Ga4ContentType.wishlist,
                        imLocation: Ga4EventLocation.wishlist,
                        imType: 'wishlist',
                        imActionType: action.type === ShowWishlistAnalytics.type
                            ? GA4ImActionType.ver_wishlist
                            : GA4ImActionType.ver_miniwishlist,
                        imLinkText: linktext,
                    },
                });
            })
        ));

    public removeWishlistItem$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DeleteItemWishlistAction, LoadShopCartSuccessAndDeleteItemFromWishlist),
            concatLatestFrom(({ item }) => this.getWishlistItem(String(item.productId))),
            filter(([_, item]) => !!item),
            map(([_, item]) => {
                return GA4AnalyticsPublicActions.Ga4Event({
                    name: GA4EventType.select_content,
                    eventFrom: undefined,
                    data: {
                        contentId: item.reference,
                        contentType: Ga4ContentType.wishlist,
                        imLocation: Ga4EventLocation.wishlist,
                        imType: 'wishlist',
                        imActionType: GA4ImActionType.eliminar_producto_wishlist,
                        items: [item],
                    },
                });
            })
        ));

    private getWishlistItem(productId: string) {
        return this.store.select(WishlistPublicSelectors.getWishlistItems).pipe(
            map((items) => {
                return items.find(content => content.id === productId);
            })
        );
    }

    public updateProductSize$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AdjustItemSizeShopcart),
            map(({ item, size }) => {
                const addedProduct: ApiSizeInfo = {
                    ...item.colors.find((color) => color.id === item.colorId)?.sizes
                        .find((_size) => _size.sku === size.sku),
                };
                const sizeName = addedProduct.name;
                delete addedProduct.name;

                const product = { ...item, ...addedProduct, size: sizeName } as unknown as CartItem;

                return SeleccionarTallaAnalytics({
                    data: {
                        action: undefined,
                        categoryId: undefined,
                        cf: undefined,
                        needsEcommerce: undefined,
                        product,
                    },
                });
            })
        );
    });

    public changeSizeProduct$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SeleccionarTallaAnalytics),
            map(({ data: { product, parentType } }) => {
                return GA4AnalyticsPublicActions.Ga4Event({
                    name: GA4EventType.select_content,
                    eventFrom: undefined,
                    data: {
                        contentId: product.reference,
                        contentType: Ga4ContentType.product_size,
                        imActionType: GA4ImActionType.seleccionar_talla,
                        items: [product] as Product[],
                        imLinkText: 'status' in product ? product.status.selectedSize?.name : product.size,
                        relatedProductType: parentType,
                    },
                });
            })
        ));

    public feelSuscriptionHeaderJoinEvent$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ClickHeaderFeelJoinAnalytics),
            // REF-AN-8
            concatLatestFrom(() => this.translateService.get('dev.myAccount.feel.join')),
            map(([_, imLinkText]) => GA4AnalyticsPublicActions.Ga4Event({
                name: GA4EventType.select_content,
                eventFrom: EventFrom['app-feel-subscription-modal'],
                data: {
                    contentType: Ga4ContentType.loyalty,
                    imActionType: GA4ImActionType.unir_programa,
                    imLinkText,
                },
            }))
        );
    });
}
